// extracted by mini-css-extract-plugin
export default {"address":"info_address__9k+rj","text":"info_text__t3+0F","href":"info_href__nH9Se"};